import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GetEmailDto, EmailPreviewDto } from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { emailForGrid } from '../../../spd/components/Emails/Emails';

export type EmailEntity = GetEmailDto;

export interface EmailContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    onlyNotSent?: boolean,
    setRefresh?: () => void,
    setLoading?: (loading: boolean) => void,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, onlyNotSent?: boolean) => Promise<number>;
  changeToInactive: (id: string) => Promise<void>;
  sendJudgmentByEmail: (
    judgmentId: string,
    english: boolean,
  ) => Promise<GetEmailDto>;
  sendReferralByEmail: (referralId: string) => Promise<GetEmailDto>;
  resend: (id: string, overrideTo?: string) => Promise<GetEmailDto>;
  sendAllWaitingEmails: () => Promise<string>;
  sendPsychologicalCardSummary: (id: string) => Promise<GetEmailDto>;
  preview: (id: string) => Promise<EmailPreviewDto>;
}

export const EmailContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      onlyNotSent = true,
      setRefresh?: () => void,
      setLoading?: (loading: boolean) => void,
    ) => {
      const data = await api.emailControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        onlyNotSent,
      );
      return data.map(email => emailForGrid(email, setRefresh, setLoading));
    },

    changeToInactive: (id: string) => api.emailControllerChangeToInactive(id),

    getAllCount: (filterText?: string, onlyNotSent = true) =>
      api.emailControllerGetAllCount(filterText || '', onlyNotSent),

    sendJudgmentByEmail: (judgmentId: string, english: boolean) =>
      api.emailControllerSendJudgmentByEmail(judgmentId, english),

    sendReferralByEmail: (referralId: string) =>
      api.emailControllerSendReferralByEmail(referralId),

    resend: (id: string, overrideTo?: string) =>
      api.emailControllerResendEmail(id, overrideTo || ''),

    sendAllWaitingEmails: () => api.emailControllerSendAllWaitingEmails(),

    sendPsychologicalCardSummary: (id: string) =>
      api.emailControllerSendPsychologicalCardSummary(id),

    preview: (id: string) => api.emailControllerPreview(id),
  };
};
